import React from 'react';
import PropTypes from 'prop-types';

const VehicleSummaryPicker = ({
  closeModal,
  handleChange,
  options,
  selected,
  handleSubmit,
}) => (
  <div className="ch-modal ch-modal--xs ch-width--12 ch-pa--3 summary-picker">
    <h3 className="ch-fs--3">Add to your vehicle summary</h3>
    <button className="ch-modal__close" onClick={closeModal} type="button">
      <span className="ch-reader">Close</span>
    </button>
    <div className="ch-form__group ch-mt--2 sm:ch-mt--4">
      {options.map((key) => {
        return (
          <div className="summary-picker__checkbox ch-pa--2" key={key}>
            <input
              checked={selected.includes(key)}
              className="ch-checkbox"
              id={key}
              name="specs"
              onChange={() => handleChange(key)}
              type="checkbox"
            />
            <label
              className="ch-checkbox__label ch-checkbox__label--right ch-checkbox__label--primary ch-display--flex ch-justify-content--between ch-fs--2"
              htmlFor={key}
            >
              {key}
            </label>
          </div>
        );
      })}
    </div>
    <div className="ch-display--flex ch-justify-content--between">
      <button className="ch-btn" onClick={closeModal} type="button">
        Cancel
      </button>
      <button
        className="ch-btn ch-btn--primary ch-ph--3"
        onClick={handleSubmit}
        type="button"
      >
        Save
      </button>
    </div>
  </div>
);

export default VehicleSummaryPicker;

VehicleSummaryPicker.propTypes = {
  closeModal: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.array,
};
